import React, { FC } from "react";
import { Icon } from "@evergis/ui";

import { DnDAnchor, ListItem } from "../styled";
import { LayerGroup } from "./LayerGroup";
import { useIsShared } from "../../../hooks/api/useIsShared";
import { usePresentationMode } from "../../../hooks/layout/usePresentationMode";
import { DraggableLayerGroupProps } from "../types";

export const DraggableLayerGroup: FC<DraggableLayerGroupProps> = ({
  layer,
  provided,
  snapshot,
  isExpanding,
  isSelectable,
  isSelected,
  noMenu,
  noControl,
  toggleSelected,
  onGroupExpand,
}) => {
  const { isDragging } = snapshot;
  const isShared = useIsShared();
  const { isPresentationMode } = usePresentationMode();

  return (
    <ListItem
      ref={provided.innerRef}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      isDragging={isDragging}
      zIndex={isExpanding ? 0 : 1}
    >
      {!isShared && !isPresentationMode && !noControl && (
        <DnDAnchor visible={isDragging}>
          <Icon kind={"dragdrop"} />
        </DnDAnchor>
      )}
      <LayerGroup
        layer={layer}
        isDragging={isDragging}
        isExpanding={isExpanding}
        isSelectable={isSelectable}
        isSelected={isSelected}
        noControl={noMenu}
        toggleSelected={toggleSelected}
        onGroupExpand={onGroupExpand}
      />
    </ListItem>
  );
};
